import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";

const ModalBox = styled(Box)(({ theme }) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '700px',
    maxHeight: '90%',
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4),
    borderRadius: '8px',
    overflowY: 'auto',
    scrollbarWidth: 'none', 
    '&::-webkit-scrollbar': {
      display: 'none', 
    },
  }));

export default ModalBox;
